import type { ProviderPublicConfig } from '@epilot/customer-portal-client'
import type { JourneySession } from '@epilot/journey-logic-commons'

/** Marks an OIDC `state` value as ours. Journeys accept arbitrary query params
 * as context values, so a callback must be detectable without guessing. */
export const SSO_STATE_PREFIX = 'jsso-'

/** A provider entry of the public portal config, rendered as a login button. */
export type SsoIdentityProvider = {
  slug: string
  display_name?: string
}

/** Everything a callback needs to finish the flow it did not start: the page
 * fully reloads between the redirect out and the redirect back. */
export type SsoFlowRecord = {
  state: string
  code_verifier: string
  /** Sent on the authorize leg; the returned id_token must echo it. */
  nonce: string
  provider: ProviderPublicConfig
  authorization_endpoint: string
  token_endpoint: string
  org_id: string
  portal_id: string
  journey_id: string
  /** Full URL (query included) put back once the callback is captured. */
  return_to: string
  /** Dedicated single-use journey snapshot, restored after the sign-in completes. */
  snapshot?: JourneySession
  created_at: number
  status: 'started' | 'consumed'
}
